import { Link } from "react-router-dom";
import { isExternal } from "@/lib/api";

export const SmartLink = ({ to, children, ...rest }) =>
  isExternal(to) ? (
    <a href={to} target="_blank" rel="noopener noreferrer" {...rest}>
      {children}
    </a>
  ) : (
    <Link to={to || "/"} {...rest}>
      {children}
    </Link>
  );

export const InfinityMark = ({ className = "" }) => (
  <svg viewBox="0 0 200 100" fill="none" className={className} aria-hidden="true">
    <path d="M100 50c-18-26-38-38-58-38C20 12 6 30 6 50s14 38 36 38c20 0 40-12 58-38zm0 0c18 26 38 38 58 38 22 0 36-18 36-38s-14-38-36-38c-20 0-40 12-58 38z" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export function Prose({ text = "" }) {
  const blocks = [];
  let list = null;
  text.split("\n").forEach((raw, i) => {
    const line = raw.trim();
    if (line.startsWith("- ")) {
      if (!list) {
        list = [];
        blocks.push({ t: "ul", items: list, k: i });
      }
      list.push(line.slice(2));
      return;
    }
    list = null;
    if (!line) return;
    if (line.startsWith("## ")) blocks.push({ t: "h3", c: line.slice(3), k: i });
    else blocks.push({ t: "p", c: line, k: i });
  });
  return (
    <div className="prose-bt">
      {blocks.map((b) =>
        b.t === "ul" ? (
          <ul key={b.k}>{b.items.map((x, j) => <li key={j}>{x}</li>)}</ul>
        ) : b.t === "h3" ? (
          <h3 key={b.k}>{b.c}</h3>
        ) : (
          <p key={b.k}>{b.c}</p>
        )
      )}
    </div>
  );
}

export const SectionHead = ({ eyebrow, title, sub, testid }) => (
  <div className="mb-10 max-w-2xl" data-testid={testid}>
    {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
    {title && <h2 className="text-3xl leading-tight sm:text-4xl">{title}</h2>}
    {sub && <p className="mt-4 text-base text-bt-text md:text-lg">{sub}</p>}
  </div>
);
